import React, { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import Scanner from "./Scanner";
import "../../css/search.css";

export default function ModalScanner({ scannerResult, onScanBarcode }) {
  const [showModalScanner, setShowModalScanner] = React.useState(false);
  const [scanning, setScanning] = React.useState(false);
  const scannerRef = React.useRef(null);
  const dialogRef = useRef(null);
  const titleId = useId();
  const closeRef = useRef(null);
  const triggerRef = useRef(null);

  function openScanner() {
    setShowModalScanner(true);
  }

  function closeScanner() {
    setShowModalScanner(false);
    setScanning(false);
    triggerRef.current?.focus();
  }

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return undefined;

    if (showModalScanner) {
      if (!dialog.open) {
        dialog.showModal();
      }
      closeRef.current?.focus();
      const scanTimer = setTimeout(() => setScanning(true), 20);

      function onBackdropClick(event) {
        if (event.target === dialog) {
          closeScanner();
        }
      }

      dialog.addEventListener("click", onBackdropClick);
      return () => {
        clearTimeout(scanTimer);
        dialog.removeEventListener("click", onBackdropClick);
      };
    }

    if (dialog.open) {
      dialog.close();
    }
    setScanning(false);
    return undefined;
  }, [showModalScanner]);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="float-button"
        aria-label="Ouvrir le scanner de code-barres"
        aria-haspopup="dialog"
        aria-expanded={showModalScanner}
        onClick={openScanner}
      >
        <span>
          <i className="fa fa-camera camera-button" aria-hidden="true" />
        </span>
      </button>
      {createPortal(
        <dialog
          ref={dialogRef}
          className="scanner-dialog"
          aria-labelledby={titleId}
          onClose={closeScanner}
          onCancel={(event) => {
            event.preventDefault();
            closeScanner();
          }}
        >
          <div className="scanner-dialog-header">
            <h3 id={titleId} className="scanner-dialog-title">
              SCANNEZ VOTRE CODE{" "}
              <i className="fas fa-barcode" aria-hidden="true" />
            </h3>
            <button
              ref={closeRef}
              type="button"
              className="back-button"
              aria-label="Fermer le scanner"
              onClick={closeScanner}
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
          <div ref={scannerRef} className="scanner-viewport">
            <canvas
              className="drawingBuffer"
              width="300"
              height="300"
            />
            {scanning ? (
              <Scanner
                scannerRef={scannerRef}
                onDetected={onScanBarcode}
              />
            ) : null}
          </div>
          <div className="scanner-dialog-footer">
            {scannerResult ? (
              <>
                <p aria-live="polite">{scannerResult}</p>
                <button
                  type="button"
                  className="scanner-search-button"
                  onClick={closeScanner}
                >
                  RECHERCHER
                </button>
              </>
            ) : (
              <p aria-live="polite">En attente du scan…</p>
            )}
          </div>
        </dialog>,
        document.body
      )}
    </>
  );
}

ModalScanner.propTypes = {
  scannerResult: PropTypes.string,
  onScanBarcode: PropTypes.func.isRequired,
};
